import './relatorio.css'
import './relatorio_gratuito.css'

import Icon from '@mdi/react';
import { useEffect } from 'react';
import { enviarTempo, registrarLog } from '../../global';
import { mdiAlertBoxOutline, mdiBusMarker, mdiBusMultiple, mdiCalculator, mdiCalendar, mdiCar, mdiCarArrowRight, mdiCarEmergency, mdiChevronDoubleDown, mdiClock, mdiClockOutline, mdiCloud, mdiHelpCircleOutline, mdiLock, mdiLockOpenVariant, mdiMapMarkerDistance, mdiMapMarkerOutline, mdiMapMarkerRadius, mdiMapMarkerRadiusOutline, mdiPlay, mdiRobber, mdiSubway, mdiSubwayVariant, mdiSunAngle, mdiSunWireless, mdiTerrain, mdiTrain, mdiTree, mdiTreeOutline, mdiWaterAlertOutline, mdiWaveArrowUp, mdiWeatherRainy, mdiWeatherSunny } from '@mdi/js';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell, CartesianGrid, LineChart, Line, Legend, } from "recharts";
import maplibregl from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";
import aparecidaIMG from './img/aparecida.jpg'
import santosIMG from './img/santos.webp'
import camposJordaoIMG from './img/camposJordao.jpg'
import seIMG from './img/se.jpg'
import MapaOnibus from './map_onibus';



export default function Gratuito({ desbloquearRelatorio, dadosIndicadores }) {

    const dadosClima = [
        { mes: "Ago", tempMin: 13, tempMax: 23, chuva: 42 },
        { mes: "Set", tempMin: 15, tempMax: 25, chuva: 68 },
        { mes: "Out", tempMin: 17, tempMax: 27, chuva: 115 },
        { mes: "Nov", tempMin: 19, tempMax: 29, chuva: 156 },
        { mes: "Dez", tempMin: 21, tempMax: 31, chuva: 228 },
        { mes: "Jan", tempMin: 22, tempMax: 32, chuva: 265 },
        { mes: "Fev", tempMin: 22, tempMax: 31, chuva: 243 },
        { mes: "Mar", tempMin: 20, tempMax: 29, chuva: 182 },
        { mes: "Abr", tempMin: 18, tempMax: 27, chuva: 104 },
        { mes: "Mai", tempMin: 15, tempMax: 24, chuva: 73 },
        { mes: "Jun", tempMin: 13, tempMax: 22, chuva: 51 },
        { mes: "Jul", tempMin: 12, tempMax: 21, chuva: 39 },
    ];
    const dadosEvolucao = [
        { mes: "Ago", total_bairro: 18, total_geral: 9 },
        { mes: "Set", total_bairro: 22, total_geral: 11 },
        { mes: "Out", total_bairro: 20, total_geral: 13 },
        { mes: "Nov", total_bairro: 27, total_geral: 15 },
        { mes: "Dez", total_bairro: 31, total_geral: 18 },
        { mes: "Jan", total_bairro: 29, total_geral: 17 },
        { mes: "Fev", total_bairro: 35, total_geral: 20 },
        { mes: "Mar", total_bairro: 38, total_geral: 22 },
        { mes: "Abr", total_bairro: 34, total_geral: 21 },
        { mes: "Mai", total_bairro: 40, total_geral: 24 },
        { mes: "Jun", total_bairro: 37, total_geral: 23 },
        { mes: "Jul", total_bairro: 43, total_geral: 27 },
    ];


    const dados = [
        { NATUREZA_APURADA: "FURTO - OUTROS", total: 42 },
        { NATUREZA_APURADA: "ROUBO - OUTROS", total: 35 },
        { NATUREZA_APURADA: "FURTO DE VEÍCULO", total: 28 },
        { NATUREZA_APURADA: "ROUBO DE VEÍCULO", total: 21 },
        { NATUREZA_APURADA: "LESÃO CORPORAL", total: 16 },
        { NATUREZA_APURADA: "AMEAÇA", total: 13 },
        { NATUREZA_APURADA: "ESTELIONATO", total: 11 },
        { NATUREZA_APURADA: "DANO", total: 8 },
    ];

    const dadosPericulosidadeHora = [
        { hora: "00h", total: 4 },
        { hora: "01h", total: 2 },
        { hora: "02h", total: 2 },
        { hora: "03h", total: 1 },
        { hora: "04h", total: 1 },
        { hora: "05h", total: 0 },
        { hora: "06h", total: 1 },
        { hora: "07h", total: 0 },
        { hora: "08h", total: 0 },
        { hora: "09h", total: 0 },
        { hora: "10h", total: 2 },
        { hora: "12h", total: 3 },
        { hora: "13h", total: 0 },
        { hora: "14h", total: 1 },
        { hora: "15h", total: 0 },
        { hora: "16h", total: 0 },
        { hora: "16h", total: 2 },
        { hora: "17h", total: 5 },
        { hora: "18h", total: 10 },
        { hora: "19h", total: 3 },
        { hora: "20h", total: 8 },
        { hora: "21h", total: 4 },
        { hora: "22h", total: 5 },
        { hora: "23h", total: 4 },
    ];

    const alturaGrafico = dados.length * 55;

    useEffect(() => {
        const inicio = Date.now();
        return () => {
            enviarTempo(
                'Relatório Gratuito - Tempo',
                inicio,
                null
            );
        };
    }, []);


    const cidade = 'São Paulo'
    const rua = 'Rua José Dantas Mahalhães Glória 202'
    const distancias = [100, 200, 300, 400]
    //const alturaGrafico = Math.max(dados.length * 80, 120);
    const latitude = -23.55028
    const longitude = -46.63389

    return (
        <div className='relatorioGratuito'>

            <div className='section-separator'></div>

            <section className='relatorio_seguranca'>
                <div className='relatorio_secao_titulo'>
                    <h1 className='secao-titulo'><Icon path={mdiPlay} size={1} color={'#c43631'} /> Detalhamento de segurança</h1>
                    <p>Fonte: Secretaria de Segurança Pública</p>
                </div>

                <div className='relatorio_principais-ocorrencias' >
                    <h1 className='title blured'><Icon path={mdiMapMarkerOutline} size={1} />Ocorrências no logradouro</h1>
                    <p className='subtitle blured'>Registros do endereço</p>
                    <div className='linhas-cards'>
                        <div className='group-line-cards group-cards blured'>

                            <div className='card-seguranca card' >
                                <div className='card-icon'>
                                    <Icon path={mdiCarEmergency} size={1.5} color={'#fff'} />
                                </div>
                                <div className='card_content'>
                                    <h2>Ocorrências totais</h2>
                                    <h1>??</h1>
                                    <h3 style={{ fontStyle: 'italic' }}>Desde 2024</h3>
                                </div>
                            </div>

                            <div className='card-seguranca card'>
                                <div className='card-icon'>
                                    <Icon path={mdiRobber} size={1.5} color={'#fff'} />
                                </div>
                                <div className='card_content'>
                                    <h2>Ocorrências no último ano</h2>
                                    <h1>??</h1>
                                    <h3 style={{ fontStyle: 'italic' }}>Considerando os últimos 12 meses</h3>
                                </div>
                            </div>

                            <div className='card-seguranca card'>
                                <div className='card-icon'>
                                    <Icon path={mdiCalculator} size={1.5} color={'#fff'} />
                                </div>
                                <div className='card_content'>
                                    <h2>Média por mês</h2>
                                    <h1>??</h1>
                                    <h3 style={{ fontStyle: 'italic' }}>Considerando os últimos 12 meses</h3>
                                </div>
                            </div>
                        </div>

                        <h1 className='title blured'><Icon path={mdiMapMarkerRadiusOutline} size={1} />Ocorrências nas imediações</h1>
                        <p className='subtitle blured'>Raio de 1 Km</p>
                        <div className='group-line-cards group-cards blured'>
                            <div className='card-seguranca card bairro-card'>
                                <div className='card-icon'>
                                    <Icon path={mdiCarEmergency} size={1.5} color={'#fff'} />
                                </div>
                                <div className='card_content'>
                                    <h2>Ocorrências totais</h2>
                                    <h1>??</h1>
                                    <h3 style={{ fontStyle: 'italic' }}>Desde 2024</h3>
                                </div>
                            </div>

                            <div className='card-seguranca card bairro-card'>
                                <div className='card-icon'>
                                    <Icon path={mdiRobber} size={1.5} color={'#fff'} />
                                </div>
                                <div className='card_content'>
                                    <h2>Ocorrências no último ano</h2>
                                    <h1>??</h1>
                                    <h3 style={{ fontStyle: 'italic' }}>Considerando os últimos 12 meses</h3>
                                </div>
                            </div>

                            <div className='card-seguranca card bairro-card'>
                                <div className='card-icon'>
                                    <Icon path={mdiCalculator} size={1.5} color={'#fff'} />
                                </div>
                                <div className='card_content'>
                                    <h2>Média por mês</h2>
                                    <h1>??</h1>
                                    <h3 style={{ fontStyle: 'italic' }}>Considerando os últimos 12 meses</h3>
                                </div>
                            </div>
                        </div>
                    </div>

                    <p className='micro-legenda' style={{ backgroundColor: '#AC302C11', borderColor: '#AC302C55', color: '#666' }}>
                        <span style={{ fontWeight: 'bold' }}><Icon path={mdiHelpCircleOutline} size={0.7} style={{ verticalAlign: '-3px' }} /> O que são essas informações?</span>
                        <br></br>
                        Registros de ocorrências diretamente associadas ao endereço analisado e em um raio de até 1km do endereço analisado, considerando os últimos 12 meses.</p>

                    <div className='block-div-unlock'>
                        <h1><Icon path={mdiLock} size={1} />Conteúdo bloqueado</h1>
                        <p>Desbloqueie o relatório para ver mais detalhes sobre ocorrências na rua e imediações.</p>
                        <button onClick={() => { desbloquearRelatorio() }}><Icon path={mdiLockOpenVariant} size={0.75} />Desbloquear</button>
                    </div>

                </div>



                <div className='grafico_ssp' style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <h1 className='title'><Icon path={mdiCalendar} size={1} />Últimos 12 meses</h1>
                    <p className='subtitle'>Ocorrências registradas no último ano a partir da disponibilidade dos dados</p>
                    <div className='block-div-unlock'>
                        <h1><Icon path={mdiLock} size={1} />Conteúdo bloqueado</h1>
                        <p>Desbloqueie o relatório para ver mais detalhes sobre a evolução das ocorrências na rua e imediações.</p>
                        <button onClick={() => { desbloquearRelatorio() }}><Icon path={mdiLockOpenVariant} size={0.75} />Desbloquear</button>
                    </div>
                    <ResponsiveContainer className='blured' width="100%" height={320}>
                        <LineChart
                            data={dadosEvolucao}
                            margin={{ top: 20, right: 30, left: 10, bottom: 10 }}
                        >
                            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e0e0e0" />
                            <XAxis
                                dataKey="mes"
                                interval="preserveStartEnd"
                                tick={{ fontSize: 13, fill: '#666' }}
                                tickLine={false}
                                axisLine={{ stroke: '#ccc' }}
                            />
                            <YAxis
                                allowDecimals={false}
                                tick={{ fontSize: 13, fill: '#666' }}
                                tickLine={false}
                                axisLine={false}
                            />
                            <Tooltip
                                formatter={(valor, nome) => [`${valor} ocorrências`, nome === 'Geral' ? 'Endereço' : 'Bairro']}
                                contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
                            />
                            <Legend wrapperStyle={{ paddingTop: '10px' }} />
                            <Line
                                type="monotone"
                                dataKey="total_bairro"
                                name="Bairro"
                                stroke="#8a1a18"
                                strokeWidth={3}
                                dot={{ r: 4, strokeWidth: 2, fill: "#fff" }}
                                activeDot={{ r: 6, strokeWidth: 0, fill: "#8a1a18" }}
                            />
                            <Line
                                type="monotone"
                                dataKey="total_geral"
                                name="Geral"
                                stroke="#e84848"
                                strokeWidth={3}
                                dot={{ r: 4, strokeWidth: 2, fill: "#fff" }}
                                activeDot={{ r: 6, strokeWidth: 0, fill: "#e84848" }}
                            />
                        </LineChart>
                    </ResponsiveContainer>

                    <p className='micro-legenda' style={{ width: '100%', backgroundColor: '#AC302C11', borderColor: '#AC302C55', color: '#666' }}>
                        <span style={{ fontWeight: 'bold' }}><Icon path={mdiHelpCircleOutline} size={0.7} style={{ verticalAlign: '-3px' }} /> O que diz o gráfico?</span>
                        <br></br>
                        Evolução temporal das ocorrências registradas no logradouro (linha em vermelho claro) e nas imediações (linha em vermelho escuro), permitindo identificar tendências recentes de segurança.</p>

                </div>

                <div className='grafico_ssp' style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <h1 className='title'><Icon path={mdiCarEmergency} size={1} />Principais ocorrências</h1>
                    <p className='subtitle'>Saiba as ocorrências mais comuns na região</p>
                    <div className='block-div-unlock'>
                        <h1><Icon path={mdiLock} size={1} />Conteúdo bloqueado</h1>
                        <p>Desbloqueie o relatório para ver quais as principais ocorrências e seus índices na região.</p>
                        <button onClick={() => { desbloquearRelatorio() }}><Icon path={mdiLockOpenVariant} size={0.75} />Desbloquear</button>
                    </div>
                    <ResponsiveContainer className='blured' height={alturaGrafico}>
                        <BarChart
                            data={dados}
                            layout="vertical"
                            margin={{ top: 20, right: 40, left: 20, bottom: 20 }}
                            barCategoryGap={15}
                        >
                            <defs>
                                <linearGradient id="barGradient" x1="0" y1="0" x2="1" y2="0">
                                    <stop offset="0%" stopColor="#e84848" stopOpacity={0.8} />
                                    <stop offset="100%" stopColor="#8a1a18" stopOpacity={1} />
                                </linearGradient>
                            </defs>
                            <YAxis
                                dataKey="NATUREZA_APURADA"
                                type="category"
                                width={180}
                                tickFormatter={(valor) => {
                                    const v = valor.toUpperCase();
                                    if (v === "ROUBO - OUTROS") return "Roubos menores";
                                    if (v === "FURTO - OUTROS") return "Furtos menores";
                                    return valor.charAt(0).toUpperCase() + valor.slice(1).toLowerCase();
                                }}
                                tick={{ fontSize: 14, fontFamily: "Nunito, sans-serif", fill: "#444", fontWeight: '600' }}
                                tickLine={false}
                                axisLine={false}
                            />
                            <XAxis
                                type="number"
                                domain={[0, (dataMax) => Math.ceil(dataMax * 1.1)]}
                                allowDecimals={false}
                                tick={{ fontSize: 13, fill: '#666' }}
                                tickLine={false}
                                axisLine={{ stroke: '#ccc' }}
                            />
                            <CartesianGrid strokeDasharray="3 3" horizontal={true} vertical={false} stroke="#e0e0e0" />
                            <Tooltip
                                formatter={(valor) => [`${valor} ocorrências`, "Total"]}
                                cursor={{ fill: 'rgba(0,0,0,0.05)' }}
                                contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
                            />
                            <Bar dataKey="total" barSize={24} radius={[0, 8, 8, 0]} fill="url(#barGradient)" />
                        </BarChart>
                    </ResponsiveContainer>

                    <p className='micro-legenda' style={{ width: '100%', backgroundColor: '#AC302C11', borderColor: '#AC302C55', color: '#666' }}>
                        <span style={{ fontWeight: 'bold' }}><Icon path={mdiHelpCircleOutline} size={0.7} style={{ verticalAlign: '-3px' }} /> O que diz o gráfico?</span>
                        <br></br>
                        Distribuição dos tipos de ocorrências mais frequentes registradas na região analisada.</p>
                </div>

                <div className='grafico_ssp' style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <h1 className='title'><Icon path={mdiClockOutline} size={1} />Índice de periculosidade por horário</h1>
                    <p className='subtitle'>*Apenas dados que o horário foi efetivamente registrado</p>


                    <div style={{ width: '100%', height: 320, marginTop: 40 }}>
                        <div className='block-div-unlock'>
                            <h1><Icon path={mdiLock} size={1} />Conteúdo bloqueado</h1>
                            <p>Desbloqueie o relatório para ver quais os horários com maiores índices de ocorrências registradas na região.</p>
                            <button onClick={() => { desbloquearRelatorio() }}><Icon path={mdiLockOpenVariant} size={0.75} />Desbloquear</button>
                        </div>
                        <ResponsiveContainer className={'blured'}>
                            <BarChart data={dadosPericulosidadeHora} margin={{ top: 20, right: 20, left: 0, bottom: 0 }}>
                                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e0e0e0" />
                                <XAxis dataKey="hora" tick={{ fontSize: 13, fill: '#666' }} tickLine={false} axisLine={{ stroke: '#ccc' }} />
                                <YAxis allowDecimals={false} tick={{ fontSize: 13, fill: '#666' }} tickLine={false} axisLine={false} />
                                <Tooltip cursor={{ fill: 'rgba(0,0,0,0.05)' }} contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }} />
                                <Bar dataKey="total" name="Ocorrências" fill="#C0392B" radius={[6, 6, 0, 0]} />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>

                    <p className='micro-legenda' style={{ width: '100%', backgroundColor: '#AC302C11', borderColor: '#AC302C55', color: '#666' }}>
                        <span style={{ fontWeight: 'bold' }}><Icon path={mdiHelpCircleOutline} size={0.7} style={{ verticalAlign: '-3px' }} /> O que diz o gráfico?</span>
                        <br></br>
                        Concentração de ocorrências por faixa horária, considerando apenas registros com horário efetivamente identificado.
                    </p>
                </div>
            </section>

            <div className='section-separator'></div>

            <section className='relatorio_clima_tempo'>
                <div className='relatorio_secao_titulo'>
                    <h1><Icon path={mdiPlay} size={1} color={'#4A90E2'} />Meio ambiente</h1>
                    <p>Histórico de clima e desastres naturais</p>
                </div>

                <h1 className='title'><Icon path={mdiWeatherSunny} size={1} />Histórico de clima - Temperatura</h1>
                <p className='subtitle'>Confira o histórico de temperatura média no último ano</p>
                <div style={{ width: '100%', height: 500, marginTop: 40, position: 'relative' }}>
                    <div className='block-div-unlock'>
                        <h1><Icon path={mdiLock} size={1} />Conteúdo bloqueado</h1>
                        <p>Desbloqueie o relatório para ver o histórico de temperatura da região.</p>
                        <button onClick={() => { desbloquearRelatorio() }}><Icon path={mdiLockOpenVariant} size={0.75} />Desbloquear</button>
                    </div>
                    <ResponsiveContainer className={'blured'}>
                        <LineChart data={dadosClima} margin={{ top: 20, right: 20, left: 0, bottom: 10 }}>
                            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e0e0e0" />
                            <XAxis dataKey="mes" tick={{ fontSize: 13, fill: '#666' }} tickLine={false} axisLine={{ stroke: '#ccc' }} />
                            <YAxis yAxisId="temp" unit="°C" tick={{ fontSize: 13, fill: '#666' }} tickLine={false} axisLine={false} />
                            <YAxis yAxisId="chuva" orientation="right" unit="mm" tick={{ fontSize: 13, fill: '#666' }} tickLine={false} axisLine={false} />
                            <Tooltip contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }} />
                            <Legend wrapperStyle={{ paddingTop: '10px' }} />
                            <Line
                                yAxisId="temp"
                                type="monotone"
                                dataKey="tempMin"
                                name="Temp. mínima (°C)"
                                stroke="#0077ff"
                                strokeWidth={3}
                                dot={{ r: 4, strokeWidth: 2, fill: "#fff" }}
                                activeDot={{ r: 6, strokeWidth: 0, fill: "#0077ff" }}
                            />
                            <Line
                                yAxisId="temp"
                                type="monotone"
                                dataKey="tempMax"
                                name="Temp. máxima (°C)"
                                stroke="#ff0044"
                                strokeWidth={3}
                                dot={{ r: 4, strokeWidth: 2, fill: "#fff" }}
                                activeDot={{ r: 6, strokeWidth: 0, fill: "#ff0044" }}
                            />
                        </LineChart>
                    </ResponsiveContainer>
                </div>
                <p className='micro-legenda' style={{ backgroundColor: '#ff205b11', borderColor: '#ff205b55', color: '#666' }}>
                    <span style={{ fontWeight: 'bold' }}><Icon path={mdiHelpCircleOutline} size={0.7} style={{ verticalAlign: '-3px' }} /> O que diz o gráfico?</span>
                    <br></br>
                    Variação mensal das temperaturas médias máximas e mínimas registradas nos últimos 12 meses.
                </p>
                <br></br>
                <h1 className='title'><Icon path={mdiWeatherRainy} size={1} />Histórico de chuvas</h1>
                <p className='subtitle'>Confira o índice pluviométrico da região no último ano</p>

                <div style={{ width: '100%', height: 360, marginTop: 40, position: 'relative' }}>
                    <div className='block-div-unlock'>
                        <h1><Icon path={mdiLock} size={1} />Conteúdo bloqueado</h1>
                        <p>Desbloqueie o relatório para ver o histórico de chuvas da região.</p>
                        <button onClick={() => { desbloquearRelatorio() }}><Icon path={mdiLockOpenVariant} size={0.75} />Desbloquear</button>
                    </div>
                    <ResponsiveContainer className={'blured'}>
                        <BarChart data={dadosClima} margin={{ top: 20, right: 20, left: 0, bottom: 10 }}>
                            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e0e0e0" />
                            <XAxis dataKey="mes" tick={{ fontSize: 13, fill: '#666' }} tickLine={false} axisLine={{ stroke: '#ccc' }} />
                            <YAxis yAxisId="chuva" unit="mm" tick={{ fontSize: 13, fill: '#666' }} tickLine={false} axisLine={false} />
                            <Tooltip cursor={{ fill: 'rgba(0,0,0,0.05)' }} contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }} />
                            <Legend wrapperStyle={{ paddingTop: '10px' }} />
                            <Bar
                                yAxisId="chuva"
                                dataKey="chuva"
                                name="Chuva (mm)"
                                fill='#4A90E2'
                                radius={[6, 6, 0, 0]}
                            />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
                <p className='micro-legenda' style={{ backgroundColor: '#77B3F811', borderColor: '#77B3F855', color: '#666' }}>
                    <span style={{ fontWeight: 'bold' }}><Icon path={mdiHelpCircleOutline} size={0.7} style={{ verticalAlign: '-3px' }} /> O que diz o gráfico?</span>
                    <br></br>
                    Cada 1 mm de chuva equivale a 1 litro de água acumulado em 1 m². O gráfico apresenta o volume mensal de precipitação registrado na região nos últimos 12 meses.</p>
            </section>



            {cidade === "São Paulo" ? <section className='relatorio_geologico'>
                <h1 className='title'><Icon path={mdiTreeOutline} size={1} />Desastres naturais</h1>
                <p className='subtitle'>Registros oficiais de eventos ambientais reportados na região durante o período analisado.</p>
                <div className='relatorio_principais-ocorrencias'>

                    <div className='block-div-unlock'>
                        <h1><Icon path={mdiLock} size={1} />Conteúdo bloqueado</h1>
                        <p>Desbloqueie o relatório para ver as ocorrências de desastres naturais na região</p>
                        <button onClick={() => { desbloquearRelatorio() }}><Icon path={mdiLockOpenVariant} size={0.75} />Desbloquear</button>
                    </div>

                    <div className='group-line-cards group-cards blured' style={{ height: 200 }}>

                        <div className='card card-inundacao'>
                            <div className='card-icon'>
                                <Icon path={mdiWaterAlertOutline} size={1.5} color={'#fff'} />
                            </div>
                            <div className='card_content'>
                                <h2>Alagamentos</h2>
                                <h1>??</h1>

                            </div>

                        </div>

                        <div className='card card-inundacao'>
                            <div className='card-icon'>
                                <Icon path={mdiWaveArrowUp} size={1.5} color={'#fff'} />
                            </div>
                            <div className='card_content'>
                                <h2>Inundações</h2>
                                <h1>??</h1>

                            </div>
                        </div>

                        <div className='card card-deslizamento'>
                            <div className='card-icon'>
                                <Icon path={mdiTerrain} size={1.5} color={'#fff'} />
                            </div>
                            <div className='card_content'>
                                <h2>Deslizamentos</h2>
                                <h1>??</h1>

                            </div>

                        </div>

                        <div className='card card-deslizamento'>
                            <div className='card-icon'>
                                <Icon path={mdiTree} size={1.5} color={'#fff'} />
                            </div>
                            <div className='card_content'>
                                <h2>Quedas de árvores</h2>
                                <h1>??</h1>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
                :
                <section className='relatorio_geologico'>
                    <h1 className='title'><Icon path={mdiTreeOutline} size={1} />Desastres naturais</h1>
                    <p className='subtitle'>Registros oficiais de eventos ambientais reportados na região durante o período analisado.</p>
                    <div className='relatorio_principais-ocorrencias'>
                        <h3 className='alert-dado-indisponivel'><Icon path={mdiAlertBoxOutline} size={0.75} /> <span>Infelizmente esses dados ainda estão indisponíveis para essa cidade, estamos constantemente trabalhando para conseguir essas informações junto à prefeitura da cidade. Em breve esse dado estará disponível.</span></h3>
                    </div>
                </section>
            }

            <div className='section-separator'></div>

            <section className='relatorio_mobilidade'>
                <div className='relatorio_secao_titulo'>
                    <h1><Icon path={mdiPlay} size={1} color={'#55b758'} />Mobilidade e Trânsito</h1>
                    <p>Disponibilidade e acesso a modais de transporte público no entorno do endereço analisado.</p>
                </div>



                <div className='relatorio_transporte'>

                    <div className='block-div-unlock'>
                        <h1><Icon path={mdiLock} size={1} />Conteúdo bloqueado</h1>
                        <p>Desbloqueie o relatório para ver detalhes sobre a mobilidade e transporte público na região. Alguns dados podem estar indisponíveis de acordo com a cidade.</p>
                        <button onClick={() => { desbloquearRelatorio() }}><Icon path={mdiLockOpenVariant} size={0.75} />Desbloquear</button>
                    </div>

                    <h1 className='title blured'><Icon path={mdiBusMarker} size={1} />Ônibus</h1>
                    <p className='subtitle blured' style={{ marginBottom: 20 }}>Pontos de ônibus nas imediações</p>

                    {cidade === 'São Paulo' ?
                        <div className='group-line-cards group-cards blured'>
                            <div className='card card-transporte'>
                                <div className='card-icon'>
                                    <Icon path={mdiBusMarker} size={1.5} color={'#fff'} />
                                </div>
                                <div className='card_content'>
                                    <h2>Pontos de Ônibus</h2>
                                    <h1>??</h1>
                                    <h3 style={{ fontStyle: 'italic' }}>Raio 1Km</h3>
                                </div>

                            </div>

                            <div className='card card-transporte'>
                                <div className='card-icon'>
                                    <Icon path={mdiBusMarker} size={1.5} color={'#fff'} />
                                </div>
                                <div className='card_content'>
                                    <h2>Ponto de Ônibus mais próximo</h2>
                                    <h1 style={{ fontSize: 22 }}>??</h1>

                                </div>

                            </div>
                        </div> :
                        <h3 className='alert-dado-indisponivel blured'><Icon path={mdiAlertBoxOutline} size={0.75} /> <span>Infelizmente os dados de pontos de ônibus ainda estão indisponíveis para essa cidade, estamos constantemente trabalhando para conseguir essas informações junto à prefeitura da cidade. Em breve esse dado estará disponível.</span></h3>
                    }
                </div>




                <h1 className='title blured'><Icon path={mdiBusMultiple} size={1} />Terminais de ônibus</h1>
                <p className='subtitle blured' style={{ marginBottom: 20 }}>Terminais de ônibus nas imediações</p>
                {cidade === 'São Paulo' ?
                    <div className='relatorio_transporte blured'>
                        <div className='group-line-cards group-cards'>
                            <div className='card card-transporte'>
                                <div className='card-icon'>
                                    <Icon path={mdiBusMultiple} size={1.5} color={'#fff'} />
                                </div>
                                <div className='card_content'>
                                    <h2>Terminais de ônibus</h2>
                                    <h1>??</h1>
                                    <h3>Raio de 5 Km</h3>
                                </div>
                            </div>
                            <div className='card card-transporte'>
                                <div className='card-icon'>
                                    <Icon path={mdiBusMultiple} size={1.5} color={'#fff'} />
                                </div>
                                <div className='card_content'>
                                    <h2>Terminal de ônibus mais próximo</h2>
                                    <h1 style={{ fontSize: 22 }}>??</h1>
                                </div>

                            </div>
                        </div>
                    </div>
                    :
                    <h3 className='alert-dado-indisponivel blured'><Icon path={mdiAlertBoxOutline} size={0.75} /> <span>Infelizmente os dados de Terminais de ônibus ainda estão indisponíveis para essa cidade, estamos constantemente trabalhando para conseguir essas informações junto à prefeitura da cidade. Em breve esse dado estará disponível.</span></h3>
                }


                <h1 className='title blured'><Icon path={mdiSubway} size={1} />Metrô</h1>
                <p className='subtitle blured' style={{ marginBottom: 10 }}>Estações de metrô nas imediações</p>
                {cidade === 'São Paulo' ?
                    <div className='relatorio_transporte blured'>
                        <div className='group-line-cards group-cards'>
                            <div className='card card-transporte'>
                                <div className='card-icon'>
                                    <Icon path={mdiSubway} size={1.5} color={'#fff'} />
                                </div>
                                <div className='card_content'>
                                    <h2>Estações de metrô próximas</h2>
                                    <h1>??</h1>
                                    <h3>Raio de 3 Km</h3>
                                </div>

                            </div>
                            <div className='card card-transporte'>
                                <div className='card-icon'>
                                    <Icon path={mdiSubway} size={1.5} color={'#fff'} />
                                </div>
                                <div className='card_content'>
                                    <h2>Estação de metrô mais próxima</h2>
                                    <h1 style={{ fontSize: 22 }}>??</h1>
                                </div>

                            </div>
                        </div>
                    </div> :
                    <h3 className='alert-dado-indisponivel'><Icon path={mdiAlertBoxOutline} size={0.75} /> <span>Infelizmente os dados de Estações de Metrô ainda estão indisponíveis para essa cidade, estamos constantemente trabalhando para conseguir essas informações junto à prefeitura da cidade. Em breve esse dado estará disponível.</span></h3>
                }


                <h1 className='title blured'><Icon path={mdiTrain} size={1} />Trem</h1>
                <p className='subtitle blured' style={{ marginBottom: 20 }}>Estações de trem nas imediações</p>

                <div className='relatorio_transporte blured'>
                    <div className='group-line-cards group-cards'>
                        <div className='card card-transporte'>
                            <div className='card-icon'>
                                <Icon path={mdiTrain} size={1.5} color={'#fff'} />
                            </div>
                            <div className='card_content'>
                                <h2>Estações de trem próximas</h2>
                                <h1>??</h1>
                                <h3>Raio de 5 Km</h3>
                            </div>
                        </div>
                        <div className='card card-transporte'>
                            <div className='card-icon'>
                                <Icon path={mdiTrain} size={1.5} color={'#fff'} />
                            </div>
                            <div className='card_content'>
                                <h2>Estação de trem mais próxima</h2>
                                <h1 style={{ fontSize: 22 }}>??</h1>

                            </div>

                        </div>
                    </div>
                </div>

                <p className='micro-legenda blured' style={{ marginTop: 20, marginBottom: 0, width: '100%', backgroundColor: '#399B3E11', borderColor: '#399B3E55', color: '#666' }}>
                    <span style={{ fontWeight: 'bold' }}><Icon path={mdiHelpCircleOutline} size={0.7} style={{ verticalAlign: '-3px' }} /> O que são essas informações?</span>
                    <br></br>
                    O detalhamento representa a infraestrutura de transporte público da região
                </p>

                <div className='relatorio_distancias blured'>
                    <h1 className='title'><Icon path={mdiCar} size={1} />Mobilidade</h1>
                    <p className='subtitle'>Tempo médio de deslocamento entre a região e pontos de referência</p>


                    <div className='relatorio_distancias_cards'>

                        <div className='distancia_card'>
                            <h1>Aparecida</h1>
                            <h2>São Paulo - Interior</h2>
                            <img className='cityPicture' src={aparecidaIMG}></img>
                            <div className='distancia_card_info'>
                                <div className='distancia-rota' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <p><span style={{ fontWeight: 'bold' }}>Partida:</span> {rua}</p>
                                    <Icon path={mdiChevronDoubleDown} size={1.5} color={'#fc7b44'} />
                                    <p><span style={{ fontWeight: 'bold' }}>Destino:</span> Aparecida, SP</p>
                                </div>

                                <div className='distancia-dados' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between', gap: 10 }}>
                                    <div className='distancia_card_tempo_desloc'>
                                        <Icon path={mdiCarArrowRight} size={1.25} />
                                        <h3>{JSON.stringify(distancias[3].tempoMinutos)} min</h3>
                                    </div>
                                    <div className='distancia_card_tempo_desloc'>
                                        <Icon path={mdiMapMarkerDistance} size={1.25} />
                                        <h3>{Math.round(distancias[3].distanciaKm)} Km</h3>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className='distancia_card'>
                            <h1>Campos do Jordão</h1>
                            <h2>São Paulo - Interior</h2>
                            <img className='cityPicture' src={camposJordaoIMG}></img>
                            <div className='distancia_card_info'>
                                <div className='distancia-rota' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <p><span style={{ fontWeight: 'bold' }}>Partida:</span> {rua}</p>
                                    <Icon path={mdiChevronDoubleDown} size={1.5} color={'#fc7b44'} />
                                    <p><span style={{ fontWeight: 'bold' }}>Destino:</span> Campos do Jordão, SP</p>
                                </div>

                                <div className='distancia-dados' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between', gap: 10 }}>
                                    <div className='distancia_card_tempo_desloc'>
                                        <Icon path={mdiCarArrowRight} size={1.25} />
                                        <h3>{JSON.stringify(distancias[0].tempoMinutos)} min</h3>
                                    </div>
                                    <div className='distancia_card_tempo_desloc'>
                                        <Icon path={mdiMapMarkerDistance} size={1.25} />
                                        <h3>{Math.round(distancias[0].distanciaKm)} Km</h3>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className='distancia_card'>
                            <h1>Santos</h1>
                            <h2>São Paulo - Litoral</h2>
                            <img className='cityPicture' src={santosIMG}></img>
                            <div className='distancia_card_info'>
                                <div className='distancia-rota' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <p><span style={{ fontWeight: 'bold' }}>Partida:</span> {rua}</p>
                                    <Icon path={mdiChevronDoubleDown} size={1.5} color={'#fc7b44'} />
                                    <p><span style={{ fontWeight: 'bold' }}>Destino:</span> Santos, SP</p>
                                </div>

                                <div className='distancia-dados' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between', gap: 10 }}>
                                    <div className='distancia_card_tempo_desloc'>
                                        <Icon path={mdiCarArrowRight} size={1.25} />
                                        <h3>{JSON.stringify(distancias[2].tempoMinutos)} min</h3>
                                    </div>
                                    <div className='distancia_card_tempo_desloc'>
                                        <Icon path={mdiMapMarkerDistance} size={1.25} />
                                        <h3>{Math.round(distancias[2].distanciaKm)} Km</h3>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className='distancia_card'>
                            <h1>Praça da Sé</h1>
                            <h2>São Paulo - Centro da capital</h2>
                            <img className='cityPicture' src={seIMG}></img>
                            <div className='distancia_card_info'>
                                <div className='distancia-rota' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <p><span style={{ fontWeight: 'bold' }}>Partida:</span> {rua}</p>
                                    <Icon path={mdiChevronDoubleDown} size={1.5} color={'#fc7b44'} />
                                    <p><span style={{ fontWeight: 'bold' }}>Destino:</span> Praça da Sé, São Paulo, SP</p>
                                </div>

                                <div className='distancia-dados' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between', gap: 10 }}>
                                    <div className='distancia_card_tempo_desloc'>
                                        <Icon path={mdiCarArrowRight} size={1.25} />
                                        <h3>{JSON.stringify(distancias[1].tempoMinutos)} min</h3>
                                    </div>
                                    <div className='distancia_card_tempo_desloc'>
                                        <Icon path={mdiMapMarkerDistance} size={1.25} />
                                        <h3>{Math.round(distancias[1].distanciaKm)} Km</h3>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>

                </div>

            </section>


            <div className='section-separator'></div>

            <section className='relatorio_locais_proximos'>
                <div className='block-div-unlock'>
                    <h1><Icon path={mdiLock} size={1} />Conteúdo bloqueado</h1>
                    <p>Desbloqueie o relatório para ver as ocorrências de desastres naturais na região</p>
                    <button onClick={() => { desbloquearRelatorio() }}><Icon path={mdiLockOpenVariant} size={0.75} />Desbloquear</button>
                </div>

                <div className='relatorio_secao_titulo'>
                    <h1><Icon path={mdiPlay} size={1} color={'#FF6F33'} />Estabelecimentos próximos</h1>
                    <p>Conheça alguns estabelecimentos próximos ao endereço</p>
                </div>

                <p className='micro-legenda blured' style={{ marginTop: 20, marginBottom: 20, width: '100%', backgroundColor: '#FF6F3311', borderColor: '#FF6F3355', color: '#666' }}>
                    <span style={{ fontWeight: 'bold' }}><Icon path={mdiHelpCircleOutline} size={0.7} style={{ verticalAlign: '-3px' }} /> O que são essas informações?</span>
                    <br></br>
                    Principais serviços e comércios localizados à uma distância de até 15 minutos do endereço (caminhando), organizados por categoria.
                </p>

                <div className='group-lists blured'>
                    <div className='location-list'>
                        <h1>Restaurantes</h1>

                        <div style={{ width: '100%', marginTop: 20 }}>
                            <p style={{ width: '100%', textAlign: 'center', color: '#666' }}>Infelizmente não encontramos nenhum restaurante registrado em nosso mecanismo de consulta. :(</p>
                        </div>
                    </div>

                    <div className='location-list'>
                        <h1>Supermercados</h1>

                        <div style={{ width: '100%', marginTop: 20 }}>
                            <p style={{ width: '100%', textAlign: 'center', color: '#666' }}>Infelizmente não encontramos nenhum supermercado registrado em nosso mecanismo de consulta. :(</p>
                        </div>

                    </div>

                    <div className='location-list'>
                        <h1>Farmácias</h1>

                        <div style={{ width: '100%', marginTop: 20 }}>
                            <p style={{ width: '100%', textAlign: 'center', color: '#666' }}>Infelizmente não encontramos nenhuma farmácia registrada em nosso mecanismo de consulta. :(</p>
                        </div>


                    </div>

                    <div className='location-list'>
                        <h1>Hospitais</h1>

                        <div style={{ width: '100%', marginTop: 20 }}>
                            <p style={{ width: '100%', textAlign: 'center', color: '#666' }}>Infelizmente não encontramos nenhum hospital registrado em nosso mecanismo de consulta. :(</p>
                        </div>


                    </div>
                </div>
            </section>
        </div>
    )
}